import { render, staticRenderFns } from "./IconReportDots.vue?vue&type=template&id=367b3693&"
import script from "./IconReportDots.vue?vue&type=script&lang=js&"
export * from "./IconReportDots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports